import { type Lead } from "../../types/lead.types.ts"

interface LeadFinancialSnapshot {
  salesPrice: number | null
  plannedPayable: number | null
  margin: number | null
  marginPercent: number | null
}

const toAmount = (value: number | string | null | undefined): number | null => {
  if (value == null || value === "") return null
  const numeric = typeof value === "string" ? parseFloat(value) : value
  return Number.isFinite(numeric) ? numeric : null
}

/**
 * Margin mirrors the edit form's Budget Summary — sales price less planned
 * payable — and stays absent while neither figure is on the lead, so an empty
 * card reads as unset rather than as a $0 margin.
 */
function leadFinancialSnapshot(lead: Lead | null): LeadFinancialSnapshot {
  const salesPrice = toAmount(lead?.sales_price)
  const plannedPayable = toAmount(lead?.planned_payable)

  const margin =
    salesPrice == null && plannedPayable == null
      ? null
      : (salesPrice ?? 0) - (plannedPayable ?? 0)

  const marginPercent =
    margin != null && salesPrice != null && salesPrice !== 0
      ? (margin / salesPrice) * 100
      : null

  return {
    salesPrice,
    plannedPayable,
    margin,
    marginPercent
  }
}

export { type LeadFinancialSnapshot, leadFinancialSnapshot, toAmount }
